export const GET_HISTORY_START='GET_HISTORY_START';
export const GET_HISTORY_SUCCESS='GET_HISTORY_SUCCESS';
export const GET_HISTORY_FAIL='GET_HISTORY_FAIL';

export const PAID_BET_START='PAID_BET_START';
export const PAID_BET_SUCCESS='PAID_BET_SUCCESS';
export const PAID_BET_FAIL='PAID_BET_FAIL';

export const SET_TYPE='SET_TYPE';